import { Typography } from "@mui/material";

const NoRecords = () => {
  return <Typography className="no-record-text">No record found.</Typography>;
};

export default NoRecords;
